import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from './queries';

export const uploadFileV2Api = createApi({
  reducerPath: 'uploadFileV2Api',
  baseQuery: (args, api, extraOptions) => baseQuery({ ...args, version: 'v2' }, api, extraOptions),
  endpoints: (builder) => ({
    getPresignedUrl: builder.mutation({
      query: ({ fileType, fileName }) => ({
        url: '/uploads/presigned_url',
        method: 'POST',
        data: { fileType, fileName },
      }),
    }),
  }),
});

export const { useGetPresignedUrlMutation } = uploadFileV2Api;
